import { render, staticRenderFns } from "./UgTab.vue?vue&type=template&id=28e1ce16&scoped=true"
import script from "./UgTab.vue?vue&type=script&lang=ts"
export * from "./UgTab.vue?vue&type=script&lang=ts"
import style0 from "./UgTab.vue?vue&type=style&index=0&id=28e1ce16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e1ce16",
  null
  
)

export default component.exports